import { Button, Col, Row } from "antd";
import { MdClose } from "react-icons/md";

import "./PostToWebsite.css";

function PostToWebsite({ setIsConfirmationBoxOpen }) {
  return (
    <div className="post-to-website-container">
      <div className="post-to-website">
        <MdClose
          className="close"
          onClick={() => setIsConfirmationBoxOpen(false)}
        />
        <h2>Please Update Required Fields</h2>
        <Row gutter={[0, 16]}>
            <Col span={24}>
                {/* Message box  */}
            </Col>
            <Col span={24}>
                <Row className="header-row">
                    <Col span={8}><span>Field Name</span></Col>
                    <Col span={16}><span>Link to Edit</span></Col>
                </Row>
                <Row className="data-row">
                    <Col span={8}><span>Available On</span></Col>
                    <Col span={16}><span className="onclick-text">Enter an available on date</span></Col>
                </Row>
            </Col>
            <Col span={24} className="buttons">
                <Row gutter={[6,0]}>
                    <Col><Button type="primary" onClick={() => setIsConfirmationBoxOpen(false)}>Save and Post</Button></Col>
                    <Col><Button onClick={() => setIsConfirmationBoxOpen(false)}>Post Anyway</Button></Col>
                    <Col><Button onClick={() => setIsConfirmationBoxOpen(false)}>Cancel</Button></Col>
                </Row>
            </Col>
        </Row>
      </div>
    </div>
  );
}

export default PostToWebsite;
